module.exports = __webpack_public_path__ + "img/nevsLogo.9744df14.png";